import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import RaisedButton from "material-ui/RaisedButton";
import { TextField } from "redux-form-material-ui";
import { connect } from "react-redux";

import Flags from "./Flags";
import { updateSpecificConfig } from "./actions";
import { maxLength } from "../../services/form";

import "../common.css";

class SpecificConfig extends Component {
  componentDidMount() {}

  render() {
    const { handleSubmit, submitCb, merchantCode, lang } = this.props;
    const submit = values => submitCb(merchantCode, values, lang);
    return (
      <div className="card-container">
        <div className="card">
          <div className="title">
            <Flags prevText="Configuration spécifique" />
          </div>
          <div className="inner">
            <span className="help">
              Attention, ces textes ont pour finalité le référencement naturel
              (SEO), merci de bien prendre en compte cette contrainte dans la
              rédaction de vos contenus
            </span>
            <form onSubmit={handleSubmit(submit)}>
              <div className="fieldset">
                <Field
                  name="subkind"
                  floatingLabelText="Sous-type d'hébergement"
                  component={TextField}
                  validate={maxLength(255)}
                />
                <div className="field-spacer" />
              </div>
              <div className="fieldset">
                <Field
                  name="short_desc_winter"
                  floatingLabelFixed
                  floatingLabelText="Description courte hiver"
                  textareaStyle={{ backgroundColor: "#fafafa" }}
                  fullWidth
                  multiLine
                  rows={3}
                  component={TextField}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="long_desc_winter"
                  floatingLabelFixed
                  floatingLabelText="Description longue hiver"
                  textareaStyle={{ backgroundColor: "#fafafa" }}
                  fullWidth
                  multiLine
                  rows={3}
                  component={TextField}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="short_desc_summer"
                  floatingLabelFixed
                  floatingLabelText="Description courte été"
                  textareaStyle={{ backgroundColor: "#fafafa" }}
                  fullWidth
                  multiLine
                  rows={3}
                  component={TextField}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="long_desc_summer"
                  floatingLabelFixed
                  floatingLabelText="Description longue été"
                  textareaStyle={{ backgroundColor: "#fafafa" }}
                  fullWidth
                  multiLine
                  rows={3}
                  component={TextField}
                />
              </div>
              <RaisedButton
                type="submit"
                secondary
                className="form-validate-btn"
                label="Valider"
              />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

SpecificConfig = reduxForm({
  form: "SpecificConfig",
  enableReinitialize: true
})(SpecificConfig);

/********* Container part */

const mapStateToProps = state => ({
  initialValues: state.accomodation,
  merchantCode: state.merchant.detail.code,
  lang: state.accomodation.lang
});

const mapDispatchToProps = dispatch => ({
  submitCb: (merchantCode, values, lang) => {
    dispatch(updateSpecificConfig(merchantCode, values, lang));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SpecificConfig);



// WEBPACK FOOTER //
// ./src/merchant/accomodation/SpecificConfig.js